<template>
  <div class="yuliang" ref="yuliang">
    <div class="select">
      <!-- 类别 -->
      <div class="storageType" >
        <span class="desc">间隔:</span>
        <div class='sjjg'>
          <el-radio v-model="radio" label="1">时</el-radio>
          <el-radio v-model="radio" label="2">日</el-radio>
        </div>
        <span class="desc">选择时间：</span>
        <el-date-picker v-model="selecttime1" :picker-options="Global.pickerOptionsStart(selecttime2)" value-format="yyyy-MM-dd HH:00:00" format="yyyy-MM-dd HH:00:00" type="datetime" placeholder="选择开始时间" default-time="08:00:00">
        </el-date-picker>
        <span class="desc">至</span>
        <el-date-picker v-model="selecttime2"  :picker-options="Global.pickerOptionsEnd(selecttime1)" value-format="yyyy-MM-dd HH:00:00" format="yyyy-MM-dd HH:00:00" type="datetime" placeholder="选择结束时间"  default-time="08:00:00">
        </el-date-picker>
      </div>
      <div>
        <span id="select" @click="searchData">查询</span>
      </div>
      <div class="export">
          <span @click="exportdata" id="export"><span class="export-icon"></span>导出</span>
      </div>
    </div>
    <div class="raintable">
      <el-table v-loading="loading" :span-method="objectSpanMethod" :row-class-name="tableRowClassName" :data="tdata" :max-height="height" border style="width: 100%;" :default-sort ="{prop:'overflowWarningWater',order:'descending'}">
        <el-table-column prop="tm" align="center" header-align="center" label="时间" min-width="150" sortable>
        </el-table-column>
        <el-table-column  prop="stnm" align="left" header-align="left" label="站名" min-width="120">
        </el-table-column>
        <el-table-column  prop="z" align="left" header-align="left" label="水位(m)" min-width="120">
        </el-table-column>
        <el-table-column  prop="maxZ" align="left" header-align="left" label="水位最大值(m)" min-width="120">
        </el-table-column>
        <el-table-column  prop="maxZOccurTM" align="left" header-align="left" label="水位最大值出现时间" min-width="160">
        </el-table-column>
        <el-table-column  prop="minZ" align="left" header-align="left" label="水位最小值(m)" min-width="120">
        </el-table-column>
        <el-table-column  prop="minZOccurTM" align="left" header-align="left" label="水位最小值出现时间" min-width="160">
        </el-table-column>
        <el-table-column  prop="avrgZ" align="left" header-align="left" label="水位平均值(m)" min-width="120">
        </el-table-column>
      </el-table>
    </div>
    <div style="float:left">
      <pager
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
        :pageIndex="query.pageIndex"
        :pageSize="query.pageSize"
        :total="query.total"
      ></pager>
    </div>
  </div>
</template>
<script>
import riverwatersituationTypes from '@/store/types/riverwatersituation'
import { Pager } from '@/components'
import timer from '@/utils/timer'
export default {
  components: {
    Pager
  },
  name: 'MonitoringCenter',
  data () {
    return {
      loading: true,
      height: 10,
      timerFun: '',
      aDDVCD: '',
      stationName: '',
      tdata: [],
      all: true,
      adcdtotal: '',
      query: {
        pageIndex: 1,
        pageSize: 20,
        total: 0
      },
      towns: [],
      checkarr: [],
      dialogVisible: false,
      sTID: '',
      time: '',
      sID: 22,
      storageType: '',
      selecttime1: '',
      selecttime2: '',
      radio: '1',
      beforeradio: '1',
      spanArr: [],
      pos: 0
    }
  },
  computed: {
  },
  methods: {
    // 列排序
    sortChange1 (a, b) {
      return a.waterAtEight - b.waterAtEight
    },
    sortChange2 (a, b) {
      return a.water - b.water
    },
    sortChange3 (a, b) {
      return a.warningWater - b.warningWater
    },
    sortChange4 (a, b) {
      return a.overflowWarningWater - b.overflowWarningWater
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.overflowWarningWater > 0) {
        console.log(row.overflowWarningWater)
        return 'warning-row'
      }
      return ''
    },
    searchData () {
      this.stationName = this.inputData
      if (this.radio !== this.beforeradio) {
        this.query.pageIndex = 1
        this.beforeradio = this.radio
      }
      this.tabledata()
    },
    tabledata () {
      this.loading = true
      this.$store.dispatch(riverwatersituationTypes.getIntervalWaterStatistics, {
        sID: this.sID,
        BeginDate: this.selecttime1,
        EndDate: this.selecttime2,
        Interval: this.radio,
        PageIndex: this.query.pageIndex,
        PageSize: this.query.pageSize
      }).then(data => {
        this.loading = false
        this.tdata = data.results
        this.getSpanArr(data.results)
        this.query.total = data.total
        // this.dataSort('overflowWarningWater', this.tdata)
      })
    },
    setListCheck: function (idx, adcd) {
      this.loading = true
      this.all = false
      var check = this.towns[idx].check
      this.towns[idx].check = !check
      let checknum = this.thecheck()
      this.addcheckarr(adcd, this.towns[idx].check)
      // console.log(adcd, this.towns[idx].check)
      // 拼接截取
      if (this.checkarr !== undefined && this.checkarr.length !== 0) {
        this.aDDVCD = ''
        this.checkarr.forEach((item) => {
          this.aDDVCD += item.substring(0, 9) + ','
        })
        this.aDDVCD = this.aDDVCD.substring(0, this.aDDVCD.length - 1)
        this.tabledata()
      }
      // 0或全选 变为全部
      if (checknum === this.adcdtotal || checknum === 0) {
        this.setAllCheck()
      }
    },
    addcheckarr: function (adcd, state) {
      if (state) {
        this.checkarr.push(adcd)
      } else {
        this.deletecheckarr(adcd)
      }
    },
    deletecheckarr: function (adcd) {
      if (this.checkarr !== undefined && this.checkarr.length !== 0) {
        this.checkarr.forEach((item, index) => {
          if (item === adcd) {
            this.checkarr.splice(index, 1)
          }
        })
      }
    },
    setAllCheck: function () {
      this.all = true
      this.checkarr = []
      this.aDDVCD = ''
      this.towns.forEach((item) => {
        item.check = false
      })
      this.tabledata()
    },
    thecheck: function () {
      let num = 0
      this.towns.forEach((item) => {
        if (item.check) {
          num++
        }
      })
      return num
    },
    // 数据排序
    dataSort (type, sortData) {
      this.sortType = type
      sortData.sort(this.compare(type))
    },
    compare (attr) {
      return function (a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val2 - val1
      }
    },
    exportdata () {
      this.$store.dispatch(riverwatersituationTypes.exportIntervalWaterStatistics, {
        sID: this.sID,
        BeginDate: this.selecttime1,
        EndDate: this.selecttime2,
        Interval: this.radio
      }).then(data => {
        let blob = new Blob([data])
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = '时段水位统计.xls'
        link.click()
        link.remove()
      })
    },
    onSizeChange (size) {
      this.query.pageSize = size
      this.loading = true
      this.tabledata()
      // this.loadTableData()
    },
    onCurrentChange (page) {
      this.query.pageIndex = page
      this.loading = true
      this.tabledata()
      // this.loadTableData()
    },
    getSpanArr (data) {
      this.spanArr = []
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1)
          this.pos = 0
        } else {
          if (data[i].stnm === data[i - 1].stnm) {
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 6 || columnIndex === 7) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    getTime () {
      var date = new Date()
      // 年
      var year = date.getFullYear()
      // 月
      var month = date.getMonth()
      // 日
      var day = date.getDate()
      var hour = date.getHours()
      this.selecttime1 = new Date(year, month, day, 8, 0, 0)
      this.selecttime2 = new Date(year, month, day, hour, 0, 0)
    }
  },
  mounted () {
    this.getTime()
    this.tabledata()
    this.timerFun = setInterval(() => {
      this.getTime()
      this.tabledata()
    }, timer.TIMER_MIN)
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      let countryListDiv = document.getElementsByClassName('countryList')
      this.$refs['yuliang'].style.height = (contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - 45) + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs['yuliang'].offsetHeight - selectDiv[0].offsetHeight - 60
    })
  },
  beforeDestroy () {
    clearInterval(this.timerFun)
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped></style>
<style lang="less" scoped>
.monitor{
  .content{
    .yuliang{
      .select{
        display: flex;
        position: relative;
        .el-input{
          width: 165px;
        }
        .export {
          position: absolute;
          right: 0;
        }
        div.storageType{
          display: flex;
          position: relative;
          bottom: 8px;
          div{
            width:220px;
          }
        }
      }
    }
  }
}
// 样式穿透
.content /deep/ .yuliang .raintable .el-table .warning-row{
  background:#f3f364 !important;
}
#station{
  width: 100%;
  height: 400px;
}
.block{
  position: absolute;
  width: 95%;
  top: 15px;
  left: 0;
  text-align: center;
}
.chartshuiwei{
    text-align: center;
    width: 100%;
    // text-align: center;
  }
.sjjg{
  margin-top: 10px;
}
</style>
